import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (!value) return null;
    const parts = value.split('/');
    if (parts.length === 3) {
      const month = +parts[0] - 1; // Months are 0-based in JS
      const day = +parts[1];
      const year = +parts[2];
      if (year < 1000 || year > 9999) { // Validate the year range
        // throw new Error('Invalid year');
        return null
      }
      const date = new Date(year, month, day);
      // console.log(date, new Date(year, month, day))
      if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
        return date;
      } else {
        throw new Error('Invalid date');
      }
    }
    return null;
  }

  override format(date: Date, displayFormat: string): string {
    if (!date) return '';
    const month = this._to2digit(date.getMonth() + 1);
    const day = this._to2digit(date.getDate());
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  private _to2digit(n: number): string {
    return ('0' + n).slice(-2);
  }
}